import axios from "axios"

export default class HealthReport {
    //Animal Health report Api
    static async getHealthReport(dataOptions, search = "") {
        const { sortBy, sortDesc, page = 1, itemsPerPage = 5 } = dataOptions
        let url = `animal/healthrecord?page=${page}&limit=${itemsPerPage}`
        if (search != "") url = `${url}&search=${search}`
        if (sortBy?.length === 1 && sortDesc?.length === 1)
            url = `${url}&col=${sortBy[0]}&desc=${sortDesc[0]}`;
        return await axios.get(url)
    }

    //Animal Treatment report Api 
    static async getTreatmentReport(dataOptions, search = "") {
        const { sortBy, sortDesc, page = 1, itemsPerPage = 5 } = dataOptions
        let url = `animal/healthrecord/treatments?page=${page}&limit=${itemsPerPage}`
        if (search != "") url = `${url}&search=${search}`
        if (sortBy?.length === 1 && sortDesc?.length === 1)
            url = `${url}&col=${sortBy[0]}&desc=${sortDesc[0]}`;
        return await axios.get(url)
    }

    // Animal Inseminator report Api
    static async getInseminatorReport(dataOptions, search = "") {
        const { sortBy, sortDesc, page = 1, itemsPerPage = 5 } = dataOptions
        let url = `animal/conception?page=${page}&limit=${itemsPerPage}`
        if (search != "") url = `${url}&search=${search}`
        if (sortBy?.length === 1 && sortDesc?.length === 1)
            url = `${url}&col=${sortBy[0]}&desc=${sortDesc[0]}`;
        return await axios.get(url)
    }
    static async getCalves(farmNumber) {
        var url = `analytics/production-analytics/calf`
        if (farmNumber) {
            url = `analytics/production-analytics/calf&farmNumber=${farmNumber}`
        }
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getCalvedaily(from, to, farmNumber) {
        var url = `analytics/production-analytics/daily-update?category=calf&from=${from}&to=${to}&farmNumber=${farmNumber}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getAnimaldata(farmNumber, ownerNumber) {
        var url = `analytics/animal-analytics/animal`
        if (farmNumber || ownerNumber) {
            url = `analytics/animal-analytics/animal&farmNumber=${farmNumber}%owner=${ownerNumber}`
        }
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getAnimaldaily(from, to, farmNumber) {
        console.log("hii", from)
        console.log("hello", to)
        console.log("yes", farmNumber)
        var url = `analytics/animal-analytics/daily-update?category=animal&from=${from}&to=${to}&farmNumber=${farmNumber}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getAnimalDisease(dataOptions, search) {
        console.log(dataOptions)
        var url = `analytics/animal-analytics/animal/disease?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if (search != '')
            url = `${url}&search=${search}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getAnimalweekly(from, to, farmNumber,ownerNumber) {
        console.log("", from)
        console.log("", to)
        var url = `analytics/animal-analytics/animal/weekly-update?from=${from}&to=${to}&farmNumber=${farmNumber}&owner=${ownerNumber}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getCalveweekly(from, to, farmNumber) {
        var url = `analytics/production-analytics/calf/weekly-update?from=${from}&to=${to}&farmNumber=${farmNumber}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getSemenProd(from, to) {
        var url=`analytics/semen-embryo/semen-prod?sDate=${from}&eDate=${to}`
        // var url = `analytics/semen-embryo/embryoProd?sDate=${from}&eDate=${to}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getEmbryoProd(from ,to) {
        var url=`analytics/semen-embryo/embryo-prod?sDate=${from}&eDate=${to}`
        // var url = `analytics/semen-embryo/embryoProd?sDate=${from}&eDate=${to}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getSemenProdStraw() {
        var url=`analytics/semen-embryo/semenProd?sDate=2020-01-01 00:00:00&eDate=2023-01-01 00:00:00`
        // var url = `analytics/semen-embryo/embryoProd?sDate=${from}&eDate=${to}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getEmbryoProdStraw() {
        var url=`analytics/semen-embryo/embryoProd?sDate=2020-01-01 00:00:00&eDate=n2023-01-01 00:00:00`
        // var url = `analytics/semen-embryo/embryoProd?sDate=${from}&eDate=${to}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getSemenSale(from, to) {
        console.log("",to)
        console.log("",from)
        var url=`analytics/semen-embryo/semen-sale?sDate=${from}&eDate=${to}`
        // var url = `analytics/semen-sale/embryoProd?sDate=${from}&eDate=${to}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getEmbryoSale(from, to) {
        console.log("",to)
        console.log("",from)
        var url=`analytics/semen-embryo/embryo-sale?sDate=${from}&eDate=${to}`
        // var url = `analytics/embryo-sale/embryoProd?sDate=${from}&eDate=${to}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getSemenEmbryoSale(from, to) {
        console.log("",to)
        console.log("",from)
        // var url = `analytics/embryo-sale/table?sDate=${from}&eDate=${to}`
        var url=`analytics/semen-embryo/table?sDate=2020-01-01 00:00:00&eDate=2023-01-01 00:00:00`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getPregnancydata(farmNumber, ownerNumber) {
        var url = `analytics/pregnency-check-analytics/history`
        if (farmNumber || ownerNumber) {
            url = `analytics/pregnency-check-analytics/history?farmNumber=${farmNumber}%owner=${ownerNumber}`
        }
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getPregnancydaily( from, to,farmNumber, userNumber,) {
        console.log("", from)
        console.log("", to)
        console.log("far", farmNumber)
        var url = `analytics/pregnency-check-analytics/daily-update?from=${from}&to=${to}&farmNumber=${farmNumber}&owner=${userNumber}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getPregnancyReport(farmNumber,ownerNumber,dataOptions,search) {
        console.log(dataOptions)
        var url = `analytics/pregnency-check-analytics?farmNumber=${farmNumber}&owner=${ownerNumber}&page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if(search != '')
            url = `${url}&search=${search}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
    static async getPregnancyweekly(from, to,farmNumber, userNumber) {
        var url = `analytics/pregnency-check-analytics/weekly-update?from=${from}&to=${to}&farmNumber=${farmNumber}&owner=${userNumber}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    }
}

